export type MediaType = 'image' | 'audio' | 'video';

export function getMediaType(file: File): MediaType | null {
    if (!file) return null;
    if (file.type.match('image.*')) return 'image';
    if (file.type.match('audio.*')) return 'audio';
    if (file.type.match('video.*')) return 'video';
    return null;
}
